import { render, staticRenderFns } from "./orderCenter.vue?vue&type=template&id=90b20994&scoped=true&"
import script from "./orderCenter.vue?vue&type=script&lang=js&"
export * from "./orderCenter.vue?vue&type=script&lang=js&"
import style0 from "./orderCenter.vue?vue&type=style&index=0&id=90b20994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b20994",
  null
  
)

export default component.exports